import React, { useRef } from "react";
import { encodeId, slugify } from "../helper/helperFunction";
import { t } from "i18next";
import { useSnackbar } from 'notistack';
import { useTranslation } from "react-i18next";
import { useCountryPrefix } from "../routes/useCountryPrefix";
import CustomImageComponent from "./CustomImageComponent";

const PropertyCard = (props) => {
  const countryPrefix = useCountryPrefix();

  const { i18n } = useTranslation();
  const language = i18n.language === "en" ? "" : i18n.language || "";

  const imageUrl = process.env.REACT_APP_IMAGE_URL;
  const {
    propertyImg,
    propertyAlt,
    tag,
    delivery,
    propertyId,
    developerDetailData,
    propertyName,
    propertyLocation,
    propertyPrice,
    propertyBed,
    propertyBath,
    propertySqft,
    contactDetails,
    isUrlAppend = false,
    projectName,
    developerName
  } = props;

  const { enqueueSnackbar } = useSnackbar();

  const handleShareClick = (path) => {

    const url = window.location

    path = url.origin + "/" + countryPrefix + (language !== '' ? "/" + language : "") + "/" + path

    // Create a temporary textarea
    const textarea = document.createElement('textarea');
    textarea.value = path;
    document.body.appendChild(textarea);

    textarea.select();
    textarea.setSelectionRange(0, 99999); // Mobile support

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        enqueueSnackbar(t("copy_message"), { variant: 'success' });
      }
    } catch (err) {
      console.error('Failed to copy', err);
    }
    document.body.removeChild(textarea);
  }
  return (
    <div className="flex-card">
      <input

        type="hidden"
        value="" // The value you want to copy
      />
      {/*<a href={`/developers/${slugify(developerDetailData?.developerName)}/property/${slugify(propertyName)}/${encodeId((propertyId))}`}></a>*/}

      <a href={isUrlAppend ? `/${countryPrefix}${language ? `/${language}` : ""}/developers/${slugify(developerName)}/project/${slugify(projectName)}/property/${slugify(propertyName)}/${encodeId((propertyId))}` : `/${countryPrefix}${language ? `/${language}` : ""}/property/${slugify(propertyName)}/${encodeId((propertyId))}`}>
        <div className="img-block">
          <CustomImageComponent
            src={propertyImg}
            alt={propertyAlt}
            className={"img-fluid pro-img"}
          />
          {tag && <span className="resale-text">{tag}</span>}
        </div>
      </a>
      <div className="content-block">
        <div className="pro-details share-block">
          <div className="left-blk">
            <span>{delivery}</span>
          </div>
          <div className="right-blk">

            <a onClick={() => handleShareClick(isUrlAppend ? `developers/${slugify(developerName)}/project/${slugify(projectName)}/property/${slugify(propertyName)}/${encodeId((propertyId))}` : `property/${slugify(propertyName)}/${encodeId((propertyId))}`)} >

              <CustomImageComponent
                src={"/assets/img/share-icon.svg"}
                alt={"Share"}
                className={"img-fluid"}
              />
            </a>
          </div>
        </div>
        <div className="pro-details">
          <div className="left-blk">
            <h4>
              <a href={isUrlAppend ? `/${countryPrefix}${language ? `/${language}` : ""}/developers/${slugify(developerName)}/project/${slugify(projectName)}/property/${slugify(propertyName)}/${encodeId((propertyId))}` : `/${countryPrefix}${language ? `/${language}` : ""}/property/${slugify(propertyName)}/${encodeId((propertyId))}`}>{propertyName}</a>
            </h4>
            <p>
              <CustomImageComponent
                src={"/assets/img/location-icon-pin.svg"}
                alt={"Location"}
                className={"img-fluid"}
              />{" "}
              {propertyLocation}
            </p>
          </div>
          <div className="right-blk">
            <h6><span style={{ fontSize: '12px' }}>{countryPrefix === 'eg' ? t('egp') : t('aed')} </span> {Intl.NumberFormat('EG', { currency: 'INR' }).format(propertyPrice)}</h6>
            {/* <span>{t("per_sqft")}</span> */}
          </div>
        </div>
        <div className="pro-details pro-details-features">
          <div className="left-blk">
            <span>
              <CustomImageComponent
                src={"/assets/img/bed-icon.svg"}
                alt={"BedCount"}
                className={"img-fluid"}
              />{" "}
              {propertyBed} {t("beds")}
            </span>
            <span>
              <CustomImageComponent
                src={"/assets/img/bath-icon.svg"}
                alt={"BathCount"}
                className={"img-fluid"}
              />
              {propertyBath} {t("baths")}
            </span>
            <span>
              <CustomImageComponent
                src={"/assets/img/area-icon.svg"}
                alt={"SqFt"}
                className={"img-fluid"}
              />
              {propertySqft} {t("Metersq")}
            </span>
          </div>
          <div className="right-blk">
            <a href={contactDetails?.phone ? `tel:${contactDetails?.phone}` : "#"}>
              <CustomImageComponent
                src={"/assets/img/call-icon.svg"}
                alt={"Phone"}
                className={"img-fluid"}
              />
            </a>
            <a href={contactDetails?.whatsApp ? `https://wa.me/${contactDetails?.whatsApp}` : "#"} target="_blank" rel="noopener noreferrer">
              <CustomImageComponent
                src={"/assets/img/whatsapp-icon.svg"}
                alt={"WhatsApp"}
                className={"img-fluid"}
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyCard;
